// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"234":"9b55a1a6","766":"43596d3c"}[chunkId] + ".js";
};